import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "../../Assets/Css/Designation.scss"
import { Spinner } from 'react-bootstrap';
import { addDesignation, updateDesignation } from '../../Services/Designation/action';
import { connect } from 'react-redux';



const AddUpdateDesignation = ({ addDesignation, updateDesignation }) => {
     const location = useLocation();
     const data = location?.state?.data?.allData;
     const [parent_designation, setparentDesignation] = useState(data?.parent_designation || "");
     const [name, setName] = useState(data?.name || "");
     const [loading, setLoading] = useState(false);
     const navigate = useNavigate()

     const hadleBack = () => {
          navigate('/designation')
     }

     const handleSave = async () => {
          try {
               setLoading(true);
               let body = {
                    name,
                    parent_designation,
               }

               if (data) {
                    await updateDesignation(data?.id, body)
               }
               else {
                    await addDesignation(body);
               }
               navigate('/designation')
          } catch (error) {
               console.error("Error adding designation:", error);
          }
          setLoading(false)
     }

     return (
               <div className="addUpdateDesignation-container">
                    <div className="page-title">
                         <h4>{data ? "Edit" : "Add"} Designation</h4>
                         <div className='d-flex justify-content-end'>
                              <div className="edit-btn">
                                   <button
                                        type="submit"
                                        className="custom-btn"
                                        onClick={hadleBack}
                                   >
                                        Cancel
                                   </button>

                                   <button
                                        type="submit"
                                        className="custom-btn"
                                        onClick={handleSave}
                                   >
                                        {loading ? (
                                             <Spinner
                                                  as="span" animation="border" role="status" aria-hidden="true" />
                                        ) : "Save"}
                                   </button>
                              </div>
                         </div>
                    </div>

                    <div className='designation-content designation-common-card'>

                         <div className='row'>
                              <div className="col-lg-6 col-md-6">
                                   <div className="input-group">
                                        <div className="label">Name</div>
                                        <input type="text" className="input-css" name='name' value={name} onChange={(e) => setName(e.target.value)} placeholder='eg. Team Lead' />
                                   </div>
                              </div>
                              <div className="col-lg-6 col-md-6">

                                   <div className="input-group">
                                        <div className="label">Parent</div>
                                        <input type="text" className="input-css" name='parentDesignation' value={parent_designation} onChange={(e) => setparentDesignation(e.target.value)} placeholder='eg. Director' />
                                        {/* <Select
                                             value={selectFilters.employee}
                                             onChange={(data) =>
                                                  setSelectedFilters({ ...selectFilters, employee: data })
                                             }
                                             options={Employees}
                                             placeholder={"--"}
                                             styles={customStyle}
                                             theme={(theme) => ({
                                                  ...theme,
                                                  colors: {
                                                       ...theme.colors,
                                                       primary25: "#5757fe",
                                                       primary: "#5757fe",
                                                  },
                                             })}
                                        /> */}
                                   </div>
                              </div>



                         </div>

                    </div>
               </div>


     );
};

export const mapStateToProps = (state) => {
     return {
          loading: state.designationReducer.loading,
     };
};

export const mapDispatchToProps = (dispatch) => {
     return {
          addDesignation: (data) => {
               dispatch(addDesignation(data));
          },
          updateDesignation: (id, data) => {
               dispatch(updateDesignation(id, data));
          }
     };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateDesignation);
